import { usePrivacy } from "providers/PrivacyProvider";
import { useR2 } from 'providers/R2Provider';
import { useEffect } from 'react';
import { NavLink } from "react-router-dom";

const MainNavLink = ({ to, label, isPrivate, children }) => {
  const { toggleMainNav, mainNavOpen } = useR2();
  const { privateMode } = usePrivacy();

  const closeSubnavs = () => {
    const subnav = document.querySelector('.mainnav__subnav--active');
    subnav?.classList.remove('mainnav__subnav--active');
  }

  const toggleSubnavHandler = (e) => {
    const mainnav = document.querySelector('.mainnav');
    mainnav.classList.remove('mainnav--hide-all-subnavs');

    const targetSubnav = e.target.nextSibling;

    if (targetSubnav.classList.contains('mainnav__subnav--active')) {
      targetSubnav.classList.remove('mainnav__subnav--active');
    } else {
      closeSubnavs();
      targetSubnav.classList.add('mainnav__subnav--active');
    }
  }

  useEffect(() => {
    closeSubnavs();
  }, [mainNavOpen]);

  if (isPrivate && !privateMode) return;

  if (to) return <div className="mainnav__mainlink"><NavLink to={to} onClick={toggleMainNav}>{label}</NavLink></div>;

  return (
    <>
      <div className="mainnav__mainlink" onClick={toggleSubnavHandler}>{label}</div>
      <div className="mainnav__subnav">
        <div className='mainnav__subnav-links-container'>
          {children}
        </div>
      </div>
    </>
  );
};

export default MainNavLink;